import styles from './Progress.module.css';

import DefaultPhoto from '../../../assets/images/Photo.png';

import { useState } from 'react';
import Observations from './Observations/Observations';
import Reflections from './Reflections/Reflections';
import Concerns from './Concerns/Concerns';
import ProgressTab from './ProgressTab/ProgressTab';
import Dropdown from '../../../components/Dropdown/Dropdown';
import ThreeDotMenu from '../../../components/ThreeDotMenu/ThreeDotMenu';
import { openModal } from '../../../redux/slices/modalSlice';
import { useDispatch } from 'react-redux';

const Progress = () => {
  const studentProfileData = [
    { heading: 'ID', data: '356467' },
    { heading: 'Age', data: '2 Yrs' },
    { heading: 'Date of Birth', data: '27/08/2025' },
    { heading: 'Admission No', data: '12358672' },
  ];

  const navigationTabs = [
    {
      label: 'Progress',
      content: <ProgressTab />,
    },
    {
      label: 'Observations',
      content: <Observations />,
    },
    {
      label: 'Reflections',
      content: <Reflections />,
    },
    {
      label: 'Concerns',
      content: <Concerns />,
    },
  ];
  const dispatch = useDispatch();

  const [activeTab, setActiveTab] = useState(navigationTabs[0].label);
  return (
    <div style={{ width: '100%', position: 'relative' }}>
      <div
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          marginBottom: '1rem',
          gap: '1rem',
        }}
      >
        <Dropdown showAllOption={false} label="Jump to Another Student" />
        <ThreeDotMenu
          options={[
            {
              label: 'Create Assesment',
              onClick: () => dispatch(openModal('')),
            },
          ]}
        />
      </div>
      <section className={styles.studentProfileDetails}>
        <header className={styles.header}>
          <p className={styles.title}>Student Details</p>
        </header>
        <main className={styles.mainContent}>
          <div className={styles.DetailsContainer}>
            <img
              src={DefaultPhoto}
              alt="Student"
              className={styles.studentPhoto}
            />
            <div className={styles.StudentData}>
              <p className={styles.studentName}>Steve John</p>
              <div className={styles.studentInfo}>
                {studentProfileData.map((item, index) => (
                  <div className={styles.infoItem} key={index}>
                    <p className={styles.infoTitle}>{item.heading}</p>
                    <p className={styles.infoData}>{item.data}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </main>
      </section>
      <section className={styles.navigationTabsSections}>
        <div className={styles.maincontainer}>
          <div className={styles.container}>
            {navigationTabs.map((item, index) => {
              return (
                <div
                  key={index}
                  className={`${styles.tabOptions} ${
                    activeTab === item.label && styles.ActivetabOption
                  }`}
                  onClick={() => setActiveTab(item.label)}
                >
                  {item.label}
                </div>
              );
            })}
          </div>
        </div>

        <div className={styles.navigationTabContainer}>
          {navigationTabs.map((item) =>
            activeTab === item.label ? item.content : null
          )}
        </div>
      </section>
    </div>
  );
};

export default Progress;
